import { union } from 'lodash';

import { MODULE_NAME } from './const';
import { useButtonDropdown } from './getters';
import { SET_BUTTON_DROPDOWN, DELETE_BUTTON_DROPDOWN } from './mutations';
import StoreModuleService from '../StoreModuleService';
import { getPlacement } from '../placements/actions';
import api from '@/api';
import { selectedProjectId as selectedProjectIdGetter } from '@/store/modules/selectedProject/getters';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import { PROJECTS_SHARED_WITH_ME_VIRTUAL_ID, VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';
const buildButtonDropdownsActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const createButtonDropdown = buildButtonDropdownsActionObject('createButtonDropdown');
export const setButtonDropdown = buildButtonDropdownsActionObject('setButtonDropdown');
export const getButtonDropdown = buildButtonDropdownsActionObject('getButtonDropdown');
export const getButtonDropdowns = buildButtonDropdownsActionObject('getButtonDropdowns');
export const updateButtonDropdown = buildButtonDropdownsActionObject('updateButtonDropdown');
export const deleteButtonDropdown = buildButtonDropdownsActionObject('deleteButtonDropdown');
export const setButtonDropdowns = buildButtonDropdownsActionObject('setButtonDropdowns');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [setButtonDropdown.action]({ commit, dispatch }, { data }) {
		await dispatch(getPlacement.fullPath, { id: data.placement }, { root: true });
		commit(SET_BUTTON_DROPDOWN, { key: data.id, value: data });
	},
	async [setButtonDropdowns.action]({ dispatch }, { data }) {
		await Promise.all(data.map((buttonDropdown) => dispatch(setButtonDropdown.action, { data: buttonDropdown })));
	},
	async [getButtonDropdowns.action]({ dispatch, rootGetters }, payload) {
		const { page, filterBy, autoPaginate } = payload;
		const selectedProjectId = rootGetters[selectedProjectIdGetter.fullPath];
		if (selectedProjectId && !VIRTUAL_PROJECT_IDS.includes(selectedProjectId)) {
			filterBy.project = selectedProjectId;
		}
		if (PROJECTS_SHARED_WITH_ME_VIRTUAL_ID === selectedProjectId) {
			filterBy.shared_with_me = true; // if we set false we actually request to exclude the projects shared with me
		}
		const data = await api.getButtonDropdowns(page, filterBy, autoPaginate);
		await dispatch(setButtonDropdowns.action, { data: data.results });
		return data;
	},
	async [getButtonDropdown.action]({ dispatch, getters }, payload) {
		const { id, forceGet } = payload;
		const buttonDropdown = getters[useButtonDropdown.getter](id);
		const needToGet = forceGet || !buttonDropdown;
		if (needToGet) {
			const buttonDropdown = await api.getButtonDropdown(id);
			await dispatch(setButtonDropdown.action, { data: buttonDropdown });
		}
	},
	async [deleteButtonDropdown.action]({ commit }, { id }) {
		await api.deleteButtonDropdown(id);
		commit(DELETE_BUTTON_DROPDOWN, { id });
	},
	async [updateButtonDropdown.action]({ dispatch, getters }, { id, data }) {
		const oldDropdownWorkflowIds = getters[useButtonDropdown.getter](id).workflows;
		const buttonDropdown = await api.updateButtonDropdown(id, data);
		await dispatch(setButtonDropdown.action, { data: buttonDropdown });
		ExtensionCommunicationService.announceButtonDropdown({ id: buttonDropdown.id });
		// in case workflows were updated, announce them to the extension
		if (data.workflows) {
			const combinedIds = union(buttonDropdown.workflows, oldDropdownWorkflowIds);
			if (combinedIds.length > 0) {
				ExtensionCommunicationService.announceWorkflows(combinedIds);
			}
		}
	},
	async [createButtonDropdown.action]({ dispatch }, payload) {
		const buttonDropdown = await api.createButtonDropdown(payload);
		await dispatch(setButtonDropdown.action, { data: buttonDropdown });
		ExtensionCommunicationService.announceButtonDropdown({ id: buttonDropdown.id });
		if (buttonDropdown.workflows.length > 0) {
			ExtensionCommunicationService.announceWorkflows(buttonDropdown.workflows);
		}
		return buttonDropdown;
	},
};

export default actions;
